import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { deriveCache } from "../util/index.js";
export function getEraCache(CACHE_KEY, era, withActive) {
  var cacheKey = "".concat(CACHE_KEY, "-").concat(era.toString());
  return [cacheKey, withActive ? undefined : deriveCache.get(cacheKey)];
}
export function getEraMultiCache(CACHE_KEY, eras, withActive) {
  var cached = withActive ? [] : eras.map(function (e) {
    return deriveCache.get("".concat(CACHE_KEY, "-").concat(e.toString()));
  }).filter(function (v) {
    return !!v;
  });
  return cached;
}
export function setEraCache(cacheKey, withActive, value) {
  !withActive && deriveCache.set(cacheKey, value);
  return value;
}
export function setEraMultiCache(CACHE_KEY, withActive, values) {
  !withActive && values.forEach(function (v) {
    return deriveCache.set("".concat(CACHE_KEY, "-").concat(v.era.toString()), v);
  });
  return values;
}
export function filterCachedEras(eras, cached, query) {
  return eras.map(function (e) {
    return cached.find(function (_ref) {
      var era = _ref.era;
      return e.eq(era);
    }) || query.find(function (_ref2) {
      var era = _ref2.era;
      return e.eq(era);
    });
  });
}